import { render, staticRenderFns } from "./DonutChartStatistics.vue?vue&type=template&id=312e9db4&"
import script from "./DonutChartStatistics.vue?vue&type=script&lang=js&"
export * from "./DonutChartStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports